<template>
    <CardRh :processando="processando" titulo="Feriados">
        <div class="feriado-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4"> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="anoFeriado" class="form-label">Ano</label>
                        <input id="anoFeriado" v-model="ano" @keyup="apertouEnter" type="number"
                            class="form-control form-control-solid" placeholder="Ano" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="dataMinFeriado" class="form-label">Data Minima</label>
                        <input id="dataMinFeriado" v-model="data_min" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="dataMaxFeriado" class="form-label">Data Maxima</label>
                        <input id="dataMaxFeriado" v-model="data_max" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-lg-4 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm mt-5" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissao" type="button" class="btn btn-pmes-primary btn-sm mt-5"
                            data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro">
                            Inserir
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width:90px">ID</th>
                    <th>Data</th>
                    <th>Tipo</th>
                    <th style="min-width:200px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>

        <Cadastro :service="service" @feriado-cadastrado="modeloAlterado" :modal="modal_cadastro" :perfis="perfis" />
        <Editar @update-feriado-alterado="modeloAlterado" :service="service" :modelo="dados" :modal="modal_atualizar" v-if="hasPermissao" :perfis="perfis" />
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import FeriadoService from "@/service/v1/sigap/FeriadoService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";

@Options({
    name: "FeriadoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar },
})
export default class FeriadoIndex extends IndexModelTable {
    public modal_turma;
    public data_min: any = null;
    public data_max: any = null;
    public ano: any = null; 

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() { 
        this.ano = null;
        this.data_min = null;
        this.data_max = null;
        this.refreshTable();
    }

    created() {
        this.service = new FeriadoService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    ano: this.ano, 
                };
                return dados;
            }
        };

        this.modal_turma = "modal_npce_turma_";
        this.modal_atualizar = "modal_hora_aulas_update_";
        this.config.columns = [
            { data: "id", name: "id", class: "desktop" },
            { data: "data", name: "data" },
            { data: "tipo.nome", name: "tipo.nome" },
        ];
        this.config.columnDefs = [
            {
                targets: 1,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + '><i class="fa fa-trash"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-editar]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
        $("[btn-excluir]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.excluirModelo(id);
        });
    }
}
</script>

<style scoped>
.feriado-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
